import { createGlobalStyle } from 'styled-components';

const GlobalFonts = createGlobalStyle`
  @font-face {
    font-family: 'LLCircularWeb';
    src: url('https://assets.bench.co/fonts/circular/lineto-circular-mediumitalic-s.eot');
    src: url('https://assets.bench.co/fonts/circular/lineto-circular-mediumitalic-s.eot?#iefix')
        format('embedded-opentype'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-mediumitalic-s.woff2')
        format('woff2'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-mediumitalic-s.woff') format('woff'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-mediumitalic-s.ttf')
        format('truetype'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-mediumitalic-s.svg#LLCircularWeb-Mediumitalic')
        format('svg');
    font-weight: 600;
    font-style: italic;
  }

  @font-face {
    font-family: 'LLCircularWeb';
    src: url('https://assets.bench.co/fonts/circular/lineto-circular-medium-s.eot');
    src: url('https://assets.bench.co/fonts/circular/lineto-circular-medium-s.eot?#iefix')
        format('embedded-opentype'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-medium-s.woff2') format('woff2'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-medium-s.woff') format('woff'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-medium-s.ttf') format('truetype'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-medium-s.svg#LLCircularWeb-Medium')
        format('svg');
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: 'LLCircularWeb';
    src: url('https://assets.bench.co/fonts/circular/lineto-circular-bookitalic-s.eot');
    src: url('https://assets.bench.co/fonts/circular/lineto-circular-bookitalic-s.eot?#iefix')
        format('embedded-opentype'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-bookitalic-s.woff2') format('woff2'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-bookitalic-s.woff') format('woff'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-bookitalic-s.ttf')
        format('truetype'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-bookitalic-s.svg#LLCircularWeb-Bookitalic')
        format('svg');
    font-weight: normal;
    font-style: italic;
  }

  @font-face {
    font-family: 'LLCircularWeb';
    src: url('https://assets.bench.co/fonts/circular/lineto-circular-book-s.eot');
    src: url('https://assets.bench.co/fonts/circular/lineto-circular-book-s.eot?#iefix')
        format('embedded-opentype'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-book-s.woff2') format('woff2'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-book-s.woff') format('woff'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-book-s.ttf') format('truetype'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-book-s.svg#LLCircularWeb-Book')
        format('svg');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'LLCircularWeb';
    src: url('https://assets.bench.co/fonts/circular/lineto-circular-bolditalic-s.eot');
    src: url('https://assets.bench.co/fonts/circular/lineto-circular-bolditalic-s.eot?#iefix')
        format('embedded-opentype'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-bolditalic-s.woff2') format('woff2'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-bolditalic-s.woff') format('woff'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-bolditalic-s.ttf')
        format('truetype'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-bolditalic-s.svg#LLCircularWeb-Bolditalic')
        format('svg');
    font-weight: bold;
    font-style: italic;
  }

  @font-face {
    font-family: 'LLCircularWeb';
    src: url('https://assets.bench.co/fonts/circular/lineto-circular-bold-s.eot');
    src: url('https://assets.bench.co/fonts/circular/lineto-circular-bold-s.eot?#iefix')
        format('embedded-opentype'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-bold-s.woff2') format('woff2'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-bold-s.woff') format('woff'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-bold-s.ttf') format('truetype'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-bold-s.svg#LLCircularWeb-Bold')
        format('svg');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'LLCircularWeb';
    src: url('https://assets.bench.co/fonts/circular/lineto-circular-blackitalic-s.eot');
    src: url('https://assets.bench.co/fonts/circular/lineto-circular-blackitalic-s.eot?#iefix')
        format('embedded-opentype'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-blackitalic-s.woff2')
        format('woff2'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-blackitalic-s.woff') format('woff'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-blackitalic-s.ttf')
        format('truetype'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-blackitalic-s.svg#LLCircularWeb-Blackitalic')
        format('svg');
    font-weight: 800;
    font-style: italic;
  }

  @font-face {
    font-family: 'LLCircularWeb';
    src: url('https://assets.bench.co/fonts/circular/lineto-circular-black-s.eot');
    src: url('https://assets.bench.co/fonts/circular/lineto-circular-black-s.eot?#iefix')
        format('embedded-opentype'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-black-s.woff2') format('woff2'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-black-s.woff') format('woff'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-black-s.ttf') format('truetype'),
      url('https://assets.bench.co/fonts/circular/lineto-circular-black-s.svg#LLCircularWeb-Black')
        format('svg');
    font-weight: 800;
    font-style: normal;
  }

  @font-face {
    font-family: 'LeituraDisplay';
    src: url('https://bench-assets.imgix.net/fonts/leitura/LeituraDisplay-Roman.subset.woff2')
      format('woff2');
    src: url('https://bench-assets.imgix.net/fonts/leitura/LeituraDisplay-Roman.subset.woff')
      format('woff');
    font-display: swap;
    font-weight: 400;
    font-style: normal;
  }
`;

export default GlobalFonts;
